<div class="popup-body" *ngIf="!customContent; else customBodyContent">
  {{ config.body }}
</div>

<ng-template #customBodyContent>
  <ng-content select="[emiCustomPopupContent]"></ng-content>
</ng-template>
